import React from 'react';
import styled, {StyledComponentClass} from "styled-components";
import {grey500} from "material-ui/styles/colors";

const DivBck = styled.div`
    position:absolute;
    z-index:1;
    display:block;
    min-height:50%;
    min-width:50%;
    top: 20%;
    right: 25%;
`;

interface PTextProps {
  fontSize: number;
}

const PText: any = styled.p`
    color: ${grey500};
    opacity: 0.4;
    font-size: ${ (props:PTextProps) => props.fontSize ? props.fontSize : 120}px;    
    transform:rotate(330deg);
`;


export const Watermark = ({text, fontSize}: {text: string, fontSize?: number}) => (
  <DivBck>
    <PText fontSize={fontSize}>{text}</PText>
  </DivBck>
);



// WEBPACK FOOTER //
// ./src/core/components/common/watermark.tsx